import { MapPin, Calendar, Phone, Mail, Globe, Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next"; // Import hook i18n

export function Footer() {
    const { t } = useTranslation('public'); // Gunakan namespace 'public'

    return (
        <footer id="contact" className="py-12 bg-card border-t">
            <div className="container mx-auto px-4">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-3 gap-8">
                        {/* Kolom 1: Logo & Tagline */}
                        <div>
                            <div className="flex items-center space-x-3 mb-4">
                                <div className="w-10 h-10 rounded-lg flex items-center justify-center">
                                    <img
                                        src="/konaspi.png"
                                        alt="Logo Konaspi"
                                        className="w-14 h-14 object-contain"
                                    />
                                </div>
                                <div>
                                    <h3 className="font-bold text-foreground">KONASPI XII</h3>
                                    <p className="text-sm text-muted-foreground">Undiksha 2026</p>
                                </div>
                            </div>
                            <p className="text-muted-foreground text-sm">
                                {t('tagline.main')}
                            </p>
                            <p className="text-muted-foreground text-sm mt-1">
                                {t('tagline.sub')}
                            </p>
                        </div>

                        {/* Kolom 2: Informasi Acara */}
                        <div>
                            <h4 className="font-semibold text-foreground mb-4">{t('footer.info_title')}</h4>
                            <div className="space-y-3 text-sm text-muted-foreground">
                                <div className="flex items-start gap-3">
                                    <Calendar className="w-4 h-4 mt-1 shrink-0" />
                                    <span>{t('footer.event_conference')}</span>
                                </div>
                                <div className="flex items-start gap-3">
                                    <MapPin className="w-4 h-4 mt-1 shrink-0" />
                                    <span>{t('hero.conference.location')}</span>
                                </div>
                                <div className="flex items-start gap-3">
                                    <Calendar className="w-4 h-4 mt-1 shrink-0" />
                                    <span>{t('footer.event_convention')}</span>
                                </div>
                                <div className="flex items-start gap-3">
                                    <MapPin className="w-4 h-4 mt-1 shrink-0" />
                                    <span>{t('hero.convention.location')}</span>
                                </div>
                            </div>
                        </div>

                        {/* Kolom 3: Kontak */}
                        <div>
                            <h4 className="font-semibold text-foreground mb-4">{t('footer.contact_title')}</h4>
                            <div className="space-y-3 text-sm text-muted-foreground">
                                {/* Telepon Kantor */}
                                <div className="flex items-center gap-3">
                                    <Phone className="w-4 h-4 shrink-0" />
                                    <a href="tel:+6236222570" className="hover:text-primary transition-colors">
                                        (0362) 22570
                                    </a>
                                </div>

                                {/* Mobile / WhatsApp */}
                                <div className="flex items-center gap-3">
                                    <Smartphone className="w-4 h-4 shrink-0" />
                                    <a href="https://wa.me/6287730060048" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                                        +62 877-3006-0048
                                    </a>
                                </div>

                                {/* Email */}
                                <div className="flex items-center gap-3">
                                    <Mail className="w-4 h-4 shrink-0" />
                                    <a href="mailto:konaspi@undiksha.ac.id" className="hover:text-primary transition-colors">
                                        konaspixii@undiksha.ac.id
                                    </a>
                                </div>

                                {/* Website */}
                                <div className="flex items-center gap-3">
                                    <Globe className="w-4 h-4 shrink-0" />
                                    <a href="https://undiksha.ac.id" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
                                        undiksha.ac.id
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="border-t border-border mt-8 pt-8 text-center">
                        <p className="text-muted-foreground text-sm">
                            {t('footer.copyright')}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}